import { render, staticRenderFns } from "./CreateConsentDocument.vue?vue&type=template&id=9291d23a"
import script from "./CreateConsentDocument.vue?vue&type=script&lang=js"
export * from "./CreateConsentDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports